var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128028(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128-028-1{fill:#fff;}.cls-128-028-2,.cls-128-028-3,.cls-128-028-4{fill:none;}.cls-128-028-2{opacity:0.2;}.cls-128-028-3{stroke:#6e6e6e;}.cls-128-028-3,.cls-128-028-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:1.25px;}.cls-128-028-4{stroke:#ff6a10;}.cls-128-028-5{fill:#969696;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-028-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-028-2",
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-028-3",
    x: 35.02,
    y: 7.41,
    width: 61.59,
    height: 113.17,
    rx: 11.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-028-3",
    x1: 35.25,
    y1: 24.89,
    x2: 96.61,
    y2: 24.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-028-3",
    x1: 35.31,
    y1: 102.26,
    x2: 96.67,
    y2: 102.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-028-3",
    cx: 65.81,
    cy: 111.65,
    r: 4.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-028-3",
    cx: 44.23,
    cy: 16.87,
    rx: 1.3,
    ry: 1.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-028-4",
    x: 47.52,
    y: 79.61,
    width: 36.82,
    height: 7.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-028-5",
    cx: 55.89,
    cy: 83.53,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-028-5",
    cx: 62.58,
    cy: 83.53,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-028-5",
    cx: 69.27,
    cy: 83.53,
    r: 1.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128-028-5",
    cx: 75.96,
    cy: 83.53,
    r: 1.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128-028-3",
    x: 52.64,
    y: 51.36,
    width: 24.68,
    height: 19.24,
    rx: 6.38,
    transform: "translate(0.12 -0.12) rotate(0.11)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128-028-3",
    d: "M57.23,43.22,59,39.86a4.9,4.9,0,0,1,6.57-2.08l8.25,4.29a4.88,4.88,0,0,1,2.08,6.56L73.76,52"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-128-028-3",
    cx: 64.98,
    cy: 59.42,
    rx: 1.45,
    ry: 1.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-028-3",
    x1: 64.98,
    y1: 61.33,
    x2: 64.98,
    y2: 65.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128-028-3",
    x1: 61.66,
    y1: 16.59,
    x2: 69.97,
    y2: 16.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128028);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_028.aff4a14154ef06a2fbc9212330aff6f6.svg";
export { ForwardRef as ReactComponent };